const CHECK_INTERVAL_IN_SECONDS = 5;

export const isLastCredit = (endTime: number, duration: number) =>
    Math.abs(duration - endTime) <= CHECK_INTERVAL_IN_SECONDS;
